import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";
import OrganizationAppResource from "./OrganizationAppResource";
import PlaybookAppResource from "./PlaybookAppResource";
import MLSAppResource from "./MLSAppResource";

class HubInvitationSettingsAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'hub-invitation-settings';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'hubs/invitations/settings';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userUuid',
            'organizationUuid',
            'playbookUuid',
            'mlsUuid',
        ];
    }

    /**
     * @return {{}}
     */
    relationMap() {
        return {
            user: UserAppResource,
            organization: OrganizationAppResource,
            playbook: PlaybookAppResource,
            mls: MLSAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
            organization: 'organization_uuid',
            playbook: 'playbook_uuid',
            mls: 'mls_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            userUuid: {
                type: 'string',
            },
            organizationUuid: {
                type: 'string',
            },
            playbookUuid: {
                type: 'string',
            },
            mlsUuid: {
                type: 'string',
            },
        };
    }

}

export default HubInvitationSettingsAppResource;
